import type {
  MetricsAwsTargetsRequest,
  ServiceDependencyParams,
  UpdateServiceQueryKeyParams
} from 'queries/services/types'

interface WithTeamId {
  teamId: string
}

export const serviceQueryKeys = {
  getMetricsAwsTargets: ({
    awsResource,
    serviceId,
    ...queryParams
  }: MetricsAwsTargetsRequest) =>
    [
      {
        baseUrl: `services/${serviceId}/metrics/${awsResource}`,
        queryParams,
        required: {
          awsResource,
          serviceId
        }
      }
    ] as const
}

export const serviceMutationKeys = {
  createDependency: ({
    serviceId,
    ...params
  }: Pick<ServiceDependencyParams, 'serviceId'> & WithTeamId) =>
    [`services/${serviceId}/dependencies`, params] as const,
  editDependency: ({
    dependencyId,
    serviceId,
    ...params
  }: ServiceDependencyParams & WithTeamId) =>
    [`services/${serviceId}/dependencies/${dependencyId}`, params] as const,
  deleteDependency: ({
    dependencyId,
    serviceId,
    ...params
  }: ServiceDependencyParams & WithTeamId) =>
    [`/services/${serviceId}/dependencies/${dependencyId}`, params] as const,
  updateService: ({ serviceId, ...params }: UpdateServiceQueryKeyParams) =>
    [`services/${serviceId}`, params] as const
}
